/* global fogo_l10n, google */

import $ from 'jquery';
import Mustache from 'mustache';
import GMap from '../helpers/gmap';
import { prepareFormValidation } from '../helpers/form';
import logger from '../helpers/logger';

// @ts-ignore
const { locationsData, showLocationInfoWindow } = window;
let gMap;
let $locationsContainer;
let $noResultsText;
let $locationsMsg;
let allLocationsBounds;
const activeClassName = 'active';
let activeLocationId;
let resultsFound = true;
let titleResultsFound = true;

const locationTemplate = `
<div class="map-location">
    <div class="map-location__wrapper">

        <div class="location {{ activeClass }}" data-location-id="{{ locationID }}">
            <div class="location__wrapper">
                <div class="location__link u-visible@lg u-hidden@sm u-hidden@md">
                    <a href="#" class="link">
                        <span class="set-location">${
                            fogo_l10n.text.setLocation
                        }</span>
                        <span class="current-location">${
                            fogo_l10n.text.currentLocation
                        }</span>
                    </a>
                </div>
                <div class="u-flex-inline u-flex-items-center">
                    <div class="location__number">{{ num }}</div>
                    <div class="location__title">{{ title }}</div>
                </div>
                <div class="location__address" x-ms-format-detection="none">
                    <span>{{ address1 }}</span><br>
                    <span>{{ address2 }}</span><br>
                    <span>{{ phone }}</span>
                </div>
                <div class="location__buttons {{hide_location_page_items}}">
                    <ul class="location__btn-list">
                        <li class="u-hidden@lg btn btn--outline">
                            <div class="location__link location__link-alt">
                                <a href="#" class="">
                                    <span class="set-location">${
                                        fogo_l10n.text.setLocation
                                    }</span>
                                    <span class="current-location">${
                                        fogo_l10n.text.currentLocation
                                    }</span>
                                </a>
                            </div>
                        </li>
                        <li class="btn btn--outline {{hide_menu_button_loc_page}}"><a target="{{ linksTarget }}" href="{{ menu_url }}" >${
                            fogo_l10n.text.menu
                        }</a></li>
                        <li class="btn btn--outline"><a target="{{ linksTarget }}" href="{{ url }}" >${
                            fogo_l10n.text.viewDetails
                        }</a></li>
                        <li class="btn btn--outline {{ reserveBtnClass }}"><a target="{{ linksTarget }}" href="/reservations?location={{ id }}">${
                            fogo_l10n.text.reserveTable
                        }</a></li>
                        <li class="btn btn--outline {{ caterBtnClass }}"><a target="{{ linksTarget }}" href="/catering">${
                            fogo_l10n.text.catering
                        }</a></li>
                        <li class="btn btn--outline {{ toGoBtnClass }}"><a target="{{ toGoTarget }}" href="{{ toGoURL }}">${
                            fogo_l10n.text.toGo
                        }</a></li>
                        <li class="btn btn--outline {{ grpExtClass }}"><a target="{{ grpExtTarget }}" href="{{ grpExtURL }}">${
                            fogo_l10n.text.external_link
                        }</a></li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</div>
`;

const mapStyles = [
    {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#444444' }],
    },
    {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [{ visibility: 'on' }, { color: '#f6f6f1' }],
    },
    {
        featureType: 'landscape.natural.landcover',
        elementType: 'labels',
        stylers: [{ color: '#ff0000' }],
    },
    {
        featureType: 'poi',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'road',
        elementType: 'all',
        stylers: [{ saturation: -100 }, { lightness: 45 }],
    },
    {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [{ visibility: 'simplified' }],
    },
    {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'transit',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'water',
        elementType: 'all',
        stylers: [{ color: '#003b64' }, { visibility: 'on' }],
    },
];

function searchFormState(state, $formSubmit) {
    switch (state) {
        case 'disable':
            $formSubmit.toggleClass('map-search--disabled', true);
            // .prop('disabled', true);
            break;

        default:
        case 'enable':
            $formSubmit.toggleClass('map-search--disabled', false);
            // .prop('disabled', false);
            break;
    }
}

function showNoLocationsMessage(message) {
    const defMessage = message || fogo_l10n.text.noLocationsFound;

    $noResultsText.find('.location__text span').text(defMessage);

    $locationsMsg.trigger('hide');
    $locationsContainer.html($noResultsText.html());

    $('.map-locations__content').css('height', '175px');
}

/**
 * When the user selects a location by clicking the
 * link "Select Location".
 */
function handleLocationSelection() {
    $(document).on('click', '.location__link a', evt => {
        evt.preventDefault();

        const $link = $(evt.target);
        const $location = $link.closest('.location');
        const locId = $location.data('locationId');
        const { lat, lng, url, title } = locationsData[locId];
        const latLng = new google.maps.LatLng(lat, lng);

        activeLocationId = locId;

        $('.location').removeClass(activeClassName);
        $location.addClass(activeClassName);

        gMap.setCenter(latLng, 13);

        window.fogoChangeTopLocation(title, url, locId);
    });
}

/**
 * Returns the HTML of the location to populate the
 * container of locations.
 */
function renderLocationHtml(num, locId, locData) {
    return Mustache.render(locationTemplate, {
        num: String(num),
        id: locId,
        title: locData.title,
        alternateTitle: locData.alternate_title,
        url: locData.url,
        menu_url: locData.menu_url,
        address1: locData.address1,
        address2: locData.address2,
        phone: locData.phone,
        locationID: locId,
        activeClass: activeLocationId === locId ? activeClassName : '',
        reserveBtnClass: locData.reservAval ? '' : 'u-hidden',
        caterBtnClass: locData.catering ? '' : 'u-hidden',
        toGoBtnClass: locData.toGoURL === '' ? 'u-hidden' : '',
        toGoURL: locData.toGoURL,
        linksTarget: locData.linksTarget,
        toGoTarget: locData.toGoTarget,
        grpExtClass: locData.grpExtURL === '' ? 'u-hidden' : '',
        grpExtURL: locData.grpExtURL,
        grpExtTarget: locData.grpExtTarget,
        region: locData.region === 'Coming-Soon' ? 'Coming Soon' : '',
        coming_soon_url: locData.coming_soon_url ? 'Coming Soon' : '',
        coming_soon_url_div: locData.region === 'Coming-Soon' ? '' : 'u-hidden',
        hide_location_page_items: locData.hide_location_page_items
            ? 'u-hidden'
            : '',
        hide_menu_button_loc_page: locData.hide_menu_button_loc_page
            ? 'u-hidden'
            : '',
    });
}

function buildLocationsInBound(actualBounds) {
    $locationsContainer.html('');

    let num = 0;
    const center = actualBounds.getCenter();

    gMap.sortLocationsByDistance(center);

    gMap.markers.forEach(marker => {
        const shouldBeVisible = actualBounds.contains(marker.position);
        let label = '';
        let map = null;

        if (resultsFound === true && shouldBeVisible === true) {
            num += 1;

            label = num.toString();
            map = gMap.map;

            $locationsContainer.append(
                renderLocationHtml(
                    num,
                    marker.cv_id,
                    locationsData[marker.cv_id],
                ),
            );
        }

        $('.map-locations__content').css('height', '600px');

        // Setting the label for the marker in the map.
        marker.setLabel(label);

        // Add or remove from the map.
        marker.setMap(map);
    });

    if (num === 0) {
        showNoLocationsMessage();
        searchFormState('disable', $('.map-search'));
    }
}

function calcMetersToMiles(meters) {
    return meters * 0.000621371192;
}

function calcMilesToMeters(miles) {
    return miles * 1609.344;
}

function showLocationsFrom(latLng, range) {
    const circle = new google.maps.Circle({
        // map: gMap.map,
        // strokeColor: '#FF0000',
        // strokeOpacity: 0.8,
        // strokeWeight: 2,
        // fillColor: '#FF0000',
        // fillOpacity: 0.35,
        center: latLng,
        radius: calcMilesToMeters(range),
    });

    gMap.map.fitBounds(circle.getBounds());
}

/**
 * Rebuilts the list of locations based on the user's location.
 */
function locateUser() {
    $locationsMsg.trigger('show', [fogo_l10n.text.loadingPosition, 'info']);

    /**
     * Get the user location.
     */
    gMap.locateUser((error, userlatLng) => {
        if (error) {
            showNoLocationsMessage(fogo_l10n.text.weCantFindYou);
            searchFormState('disable', $('.map-search'));

            gMap.markers.forEach(marker => {
                marker.setLabel('');
                marker.setMap(gMap.map);
            });

            return;
        }

        $locationsContainer.html('');
        $locationsMsg.trigger('hide');

        // Show all markers within 100 hundred miles from the user's location.
        showLocationsFrom(userlatLng, 100);
        // gMap.setCenter(latLng, 10);
    });
}

/**
 * Handles the search form.
 */
function handleSearch() {
    $('.js-search-geolocate').on('click', evt => {
        evt.preventDefault();

        locateUser();
    });

    const validate = prepareFormValidation($('.js-map-search'));

    $('.js-map-search').on('submit', evt => {
        const $form = $(evt.target);
        const formTextValue1 = $('.js-search-text', $form).val();
        const formTextValue = formTextValue1.toLowerCase();

        $form.on('keyup', e => {
            if (e.type === 'keyup' && e.which === 13) {
                $('.js-search-text').blur();
            }
        });

        $locationsMsg.trigger('hide');

        if (!validate($form)) {
            return;
        }

        $form.toggleClass('js-disabled', true);
        $locationsMsg.trigger('show', ['Loading...', 'info']);

        searchFormState('enable', $('.js-map-search'));

        const locationItems = Object.entries(locationsData);
        let centerLatLng;

        if (titleResultsFound) {
            for (var i = 0; i < locationItems.length; i++) {
                // console.log(locationItems[i]);
                let locationTitle = locationItems[i][1].title;
                let locTitle = locationTitle.toLowerCase();

                let alternateTitle = locationItems[i][1].alternate_title;
                let locAltTitle = alternateTitle.toLowerCase();

                if (locTitle.includes(formTextValue)) {
                    // console.log('true loc title')
                    centerLatLng = {lat: parseFloat(locationItems[i][1].lat), lng: parseFloat(locationItems[i][1].lng)};
                    showLocationsFrom(centerLatLng, 25);
                    $locationsMsg.trigger('hide');
                    $form.toggleClass('js-disabled', false);
                    return;
                }
                if (locAltTitle.includes(formTextValue)) {
                    // console.log('true alt loc title')
                    centerLatLng = {lat: parseFloat(locationItems[i][1].lat), lng: parseFloat(locationItems[i][1].lng)};
                    showLocationsFrom(centerLatLng, 25);
                    $locationsMsg.trigger('hide');
                    $form.toggleClass('js-disabled', false);
                    return;
                }
            }

            titleResultsFound = false;
        }

        const geocoder = new google.maps.Geocoder();

        // Geocode the user input (get latitude and longitude) and save it in an object.
        geocoder.geocode({ address: formTextValue }, (results, status) => {
            $form.toggleClass('js-disabled', false);
            $locationsMsg.trigger('hide');
            // console.log(titleResultsFound, 'geo');
            // console.log(status);
            // If there are no results, show a message.
            if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
                resultsFound = false;

                gMap.map.fitBounds(allLocationsBounds);

                searchFormState('disable', $('.js-map-search'));

                return;
            }

            const ERROR_UNEXPECTED_RESPONSE =
                'Unexpected response from Google Maps API.';
            if (status === google.maps.GeocoderStatus.OK) {
                resultsFound = true;
                if ('bounds' in results[0].geometry) {
                    centerLatLng = results[0].geometry.bounds.getCenter();
                    // gMap.map.fitBounds(results[0].geometry.bounds);
                } else if ('location' in results[0].geometry) {
                    centerLatLng = results[0].geometry.location;
                    // gMap.setCenter(results[0].geometry.location, 13);
                } else {
                    throw new Error(ERROR_UNEXPECTED_RESPONSE);
                }
                if (formTextValue.toLowerCase().includes('brazil')) {
                    showLocationsFrom(centerLatLng, 500);
                }
                // Show all markers within 100 hundred miles from the searched location.
                else {
                    showLocationsFrom(centerLatLng, 100);
                }
                return;
            }

            throw new Error(ERROR_UNEXPECTED_RESPONSE);
        });

        titleResultsFound = true;
    });
}

/**
 * Creates the map.
 */
function createMap(mapEle) {
    if (!locationsData) {
        logger.error("Variable locationsData doesn't exist.");
        return;
    }

    gMap = new GMap(mapEle);

    gMap.buildMap({ styles: mapStyles });

    gMap.placeMarkers(
        Object.entries(locationsData),
        {
            icon: {
                url: '/wp-content/themes/fogodechao/assets/images/marker-red.svg',
                scaledSize: new google.maps.Size(31, 31),
            },
        },
        ([locId, locData]) => {
            let position;

            try {
                position = new google.maps.LatLng(locData.lat, locData.lng);
            } catch (e) {
                logger.error(e);
                return null;
            }

            // Add the resulting HTML of the location to the container.
            // $locationsContainer.append(
            //     renderLocationHtml(locId, locId, locData),
            // );

            // Info needed for function google.maps.Marker.
            locationsData[locId].markerProps = {
                cv_id: parseInt(locId, 10),
                label: locId.toString(),
                url: locData.url,
                position,
                hideItem: locData.hide_location_page_items,
                icon:
                    locData.region === 'Coming-Soon'
                        ? '/wp-content/themes/fogodechao/assets/images/marker-red.svg'
                        : '/wp-content/themes/fogodechao/assets/images/marker.svg',
            };

            if (
                typeof showLocationInfoWindow === 'boolean' &&
                showLocationInfoWindow === true
            ) {
                locationsData[locId].markerProps.infoWindowContent =
                    `<div style="text-align: left"><span style="font-weight: bold">${
                        locData.title
                    }</span><br /> ` +
                    `<a href="${
                        locationsData[locId].markerProps.url
                    }">View Location</a></div>`;
            }

            return locationsData[locId].markerProps;
        },
    );

    gMap.on('loaded', () => {
        allLocationsBounds = new google.maps.LatLngBounds();

        gMap.markers.forEach(marker => {
            allLocationsBounds.extend(marker.position);
        });

        locateUser();
    });

    gMap.on('changed', actualBounds => {
        buildLocationsInBound(actualBounds);

        resultsFound = true;
    });
}

function initMap() {
    const mapEle = document.getElementById('map');

    // This should only run in Locations page.
    if (mapEle === null) {
        return;
    }

    $locationsContainer = $('.map-locations__content');
    $noResultsText = $('.map-locations__no-results-text');
    $locationsMsg = ($ele => {
        $ele.on('show', (evt, msg, type) => {
            const typeParsed = type || 'info';

            $ele.removeClass('msg--error, msg--info')
                .addClass(`msg--${typeParsed}`)
                .text(msg)
                .show();

            $('.map-locations__content').css('height', '175px');
        });

        $ele.on('hide', () => {
            $ele.text('').hide();
            $('.map-locations__content').css('height', '600px');
        });

        return $ele;
    })($('.map-locations__msg'));

    Mustache.parse(locationTemplate);

    createMap(mapEle);
    handleSearch();
    handleLocationSelection();
}

// Entrypoint.
window.initMap = initMap;
